import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';

import {PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE} from '../AnalyticsVisualizationConstants';
import {VisualizationType} from '../AnalyticsVisualizationTypes';

export default function getVisualizationType(visualization: AnalyticsVisualization): VisualizationType {
  return PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE[visualization.parameters.__typename];
}
